<template>
  <div class="index-container">
    <div class="index-banner">
      <swiper :options="swiperOption">
        <swiper-slide class="slide-item" v-for="(item,index) in bannerArr" :key="index">
          <a :href="item.url">
            <img v-lazy="item.banner" alt>
          </a>
        </swiper-slide>
        <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
      </swiper>
    </div>
    <div v-if="isLoad" class="content clearfix">
      <div class="index-left">
        <div class="news">
          <div class="tit">
            <h2>
              新闻动态
              <span>/ News</span>
            </h2>
            <router-link to="/News">more ></router-link>
          </div>
          <ul>
            <li v-for="(item,index) in newsArr" :key="index" @click="jump(item.id)">
              <span>{{item.add_time}}</span>
              {{item.news_title}}
            </li>
          </ul>
        </div>
        <div class="index-site-link">
          <div class="item">
            <router-link :to="{path: '/about',query:{index:3}}">
              <i></i>
              <div class="info">
                <h3>商务合作</h3>
                <p>携手同行，资源共享</p>
              </div>
            </router-link>
          </div>
          <div class="item">
            <router-link :to="{path: '/about',query:{index:3}}">
              <i></i>
              <div class="info">
                <h3>联系我们</h3>
                <p>没有态度，不成品牌</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="index-right">
        <a v-for="(item,index) in productArr" :key="index" :href="item.link">
          <img v-lazy="item.banner" alt>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { constants } from "fs";
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: 30,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        effect: "fade",
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      bannerArr: [],
      newsArr: [],
      productArr: [
        {
          link: "http://www.8solo.com/",
          banner: require("../assets/image/link_app.png")
        },
        {
          link: "http://www.66173.cn/",
          banner: require("../assets/image/link_game.png")
        }
      ],
      isLoad: false
    };
  },
  methods: {
    jump: function(newsId) {
      this.$router.push({ path: "/Detail", query: { newsId: newsId } });
    }
  },
  mounted: function() {
    this.axios.get("/niuniu_api.php?action=banner").then(response => {
      let res = response.data;
      if (res.errcode == 0) {
        this.bannerArr = res.data;
        this.isLoad = true;
      } else {
        console.log(res.errmsg);
      }
    });
    this.axios
      .get("/niuniu_api.php?action=news", {
        params: {
          page: 1,
          limit: 6
        }
      })
      .then(response => {
        let res = response.data;
        if (res.errcode == 0) {
          this.newsArr = res.data.news;
        } else {
          console.log(res.errmsg);
        }
      });
  }
};
</script>


<style scoped>
.index-container {
  min-height: 100vh;
}
.index-container .content {
  padding-bottom: 30px;
}
.index-banner {
  margin-bottom: 20px;
  overflow: hidden;
}
.index-banner img {
  width: 100%;
}

.news .tit {
  position: relative;
  height: 54px;
  line-height: 54px;
  border-bottom: 1px solid #f4f4f4;
  margin-bottom: 5px;
}
.news .tit h2 {
  font-size: 24px;
  background: url(../assets/image/ic_news.svg) left center no-repeat;
  background-size: 30px 30px;
  padding-left: 40px;
}
.news .tit h2 span {
  font-size: 18px;
  color: #a6a6a6;
}
.news .tit a {
  font-size: 14px;
  display: block;
  line-height: 64px;
  position: absolute;
  top: 0;
  right: 0;
}

.news li {
  height: 37px;
  line-height: 37px;
  padding-left: 5px;
  cursor: pointer;
}

.news li span {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  color: #999;
}

.news li {
  display: block;
  position: relative;
  overflow: hidden;
  font-size: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-left: 70px;
  transition: all 0.4s;
  cursor: pointer;
}

.news li:hover,
.news li:hover span,
.news .tit a:hover {
  color: #e23251;
}

.index-right a {
  display: block;
  transition: all .5s ease-out;
}

.index-right a:hover {
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.3);
  transform: translateY(-1px);
}
.index-right a:first-child {
  margin-bottom: 20px;
}
.index-right a img {
  width: 100%;
  display: block;
  border-radius: 4px;
}

.index-site-link a:hover {
  transform: translateY(5px);
}
.index-site-link a::after {
  content: "";
  width: 0;
  height: 3px;
  position: absolute;
  left: 50%;
  bottom: 0;
  transition: all 0.3s;
}
.index-site-link a:hover::after {
  width: 100%;
  margin-left: -50%;
  background-color: #de3047;
}

.index-site-link i {
  background: url(../assets/image/ic_hezuo.svg) no-repeat;
  width: 46px;
  height: 46px;
  display: block;
  float: left;
  margin: 10px 17px 0 25px;
  transition: all 0.3s;
}

.index-site-link a:hover,
.index-site-link a:hover h3 {
  color: #de3047;
}

.index-site-link .item:first-child:hover i {
  background: url(../assets/image/ic_hezuo_hover.svg) no-repeat;
}

.index-site-link .item:last-child:hover i {
  background: url(../assets/image/ic_lianxi_hover.svg) no-repeat;
}

.index-site-link .item:last-child i {
  background: url(../assets/image/ic_lianxi.svg) no-repeat;
}

.index-site-link .info h3 {
  font-size: 24px;
  margin-bottom: 15px;
}
.index-site-link .info {
  overflow: hidden;
}
.index-site-link .info p {
  font-size: 14px;
  transition: all 0.3s;
}

.index-site-link {
  padding-top: 10px;
}

.index-site-link a {
  height: 134px;
  padding-top: 30px;
  background-color: #f6f6f6;
  box-shadow: 0px 1px 3px 0px rgba(221, 221, 221, 1);
  border-radius: 4px;
  display: block;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
}
.index-site-link .item {
  margin-bottom: 20px;
}

@media (min-width: 768px) {
  .index-container .content {
    width: auto;
    margin-bottom: 80px;
  }
}
@media (min-width: 992px) {
  .index-container .content {
    width: 970px;
    margin: 0 auto;
    padding-bottom: 80px;
  }
  .index-left {
    width: 57.6%;
    float: left;
  }
  .index-right {
    width: 34.9%;
    float: right;
    padding-top: 15px;
  }

  .index-site-link {
    margin-left: -22px;
  }

  .index-site-link .item {
    width: 50%;
    float: left;
    padding-left: 22px;
  }
}
@media (min-width: 1200px) {
  .index-container .content {
    width: 1170px;
    padding-bottom: 80px;
  }
  .index-left {
    width: 57.6%;
    float: left;
  }
  .index-right {
    width: 34.9%;
    float: right;
    padding-top: 15px;
  }
}
</style>



